import { postData } from '@/utils/request';
import {
  FIND_RET_STORE_NAME,
  NEW_STAFF,
  GET_ACTIVEITY_COMMUNITY_BY_ID,
} from '../interface/staff';

const prefix = '/ldhhapi';
const staff = {
  //根据门店名称查询店铺
  findRetStoreName: (data?: FIND_RET_STORE_NAME) => {
    return postData(prefix + '/basic/store/findRetStoreName', data);
  },
  //员工扫码
  newStaff: (data?: Partial<NEW_STAFF>) => {
    return postData(prefix + '/marketing/mkActivityDrainage/newStaff', data);
  },
  //C端查询引流详情
  getActivityCommunityById: (data?: GET_ACTIVEITY_COMMUNITY_BY_ID) => {
    return postData(
      prefix + '/marketing/mkActivityDrainage/getActivityCommunityById',
      data
    );
  },
  /** 导出会员基本信息 */
  exportMemberInfo: (data?: object) => {
    return postData(prefix + '/member/customer-info/exportMemberInfo', data);
  },
};

export default staff;
